import { render } from "./CreateSubjectDialog.vue?vue&type=template&id=215d3d53"
import script from "./CreateSubjectDialog.vue?vue&type=script&lang=js"
export * from "./CreateSubjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__